import {css, LinkConfig} from '@sail/ui';
import {helmTokens} from '@sail/helm';

export const styles = {
  siteFooterLinkListStyles: css({
    stack: 'y',
    gap: 'xsmall',
    margin: 'space.0',
    padding: 'space.0',
    listStyleType: 'none',
  }),
  siteFooterListTitle: css({
    font: 'body.medium.emphasized',
    marginTop: 'space.0',
    marginBottom: 'small',
    textColor: 'emphasized',
  }),
  localeContainer: css({
    stack: 'y',
    gap: 'xsmall',
  }),
  siteFooterlinkConfig: [
    LinkConfig.customize({
      css: {
        font: 'body.medium',
        fontWeight: 'normal',
        lineHeight: '24px',
        textColor: 'action.secondary',
        ':hover': {
          textColor: 'action.secondary.hovered',
        },
        transition: `all ${helmTokens.transition.hover}`,
      },
    }),
  ],
  nonLinkItem: css({
    font: 'body.medium',
    fontWeight: 'normal',
    lineHeight: '24px',
    textColor: 'action.secondary',
  }),
  standardSohneSpacing: css({
    letterSpacing: `${helmTokens.letterSpacing.large}`,
  }),
  supportLinkNoWrap: css({
    whiteSpace: 'nowrap',
  }),
};
